import type { FC, ReactNode } from 'react'
import type { Showcase } from '@/types'

import Link from 'next/link'

interface ShowcaseCardProps {
    item: Showcase
}

export const ShowcaseCard: FC<ShowcaseCardProps> = ({ item }): ReactNode => {
    return (
        <div className='showcase-item mdl-dyn-item fade-in-move-on-scroll' role='listitem'>
            <Link href={`/showcases/${item.slug}`} className='showcase-item-link mdl-inline-block'>
                <div className='showcase-item-image-holder'>
                    <img
                        className='showcase-item-image'
                        src={item.thumbnail || item.mainImage}
                        loading='lazy'
                        alt={(item.thumbnail ? item.thumbnailAlt : item.mainImageAlt) || item.name}
                    />
                </div>
                <div className='showcase-item-content grey-showcase-item-content'>
                    <div className='showcase-item-subtitle-holder'>
                        <div className='showcase-item-subtitle' data-mdlfy-cms={`showcases:${item.id}:category`}>{item.category}</div>
                        <div className='showcase-item-subtitle'>:</div>
                    </div>
                    <div className='showcase-item-title' data-mdlfy-cms={`showcases:${item.id}:name`}>{item.name}</div>
                    <div className='slide-content-bg' />
                </div>
            </Link>
        </div>
    )
}
